import { Trans } from '@lingui/react'

import { FormSubmitButton } from '@twisto/components/atoms/button'
import type { PhoneNumberFieldFormValues } from '@twisto/components/organisms/phone-number-field'
import { PhoneNumberField } from '@twisto/components/organisms/phone-number-field'

import { useFlow } from '../../flow/flow.context'

import * as styles from './phone-number-step-form-content.styles'

export const fieldNames = {
  phoneNumber: 'phoneNumber',
} as const

export type FormValues = {
  phoneNumber: PhoneNumberFieldFormValues
}

export const PhoneNumberStepFormContent = () => {
  const { flow } = useFlow<'PhoneNumberStep'>()
  const { phoneNumber } = flow.currentStep

  const availableCallCodes = phoneNumber.availableCallCodes

  return (
    <>
      <div css={styles.field}>
        <PhoneNumberField
          autoFocus
          callingCodes={availableCallCodes}
          isRequired={phoneNumber.required}
          label={<Trans id="flow.phoneNumberStep.label" />}
          name={fieldNames.phoneNumber}
          readOnly={phoneNumber.readonly}
        />
      </div>
      <FormSubmitButton>
        <Trans id="flow.phoneNumberStep.submitButton" />
      </FormSubmitButton>
    </>
  )
}
